import React from "react";
import { Link } from 'react-router-dom';
import salesforcepic from "./Images/Salesforce-services.png";
import "./SalesForceDevelopment.css";
import { Helmet } from "react-helmet-async";

import {
    FaCloud,
    FaCogs,
    FaChartLine,
    FaLock,
    FaSyncAlt,
    FaUsers,
    FaTools,
    FaMobileAlt,
    FaCodeBranch
} from "react-icons/fa";

const SalesforceDevelopment = () => {
    return (

        
        <div className="salesforce-container">


            <Helmet>
  <title>Salesforce Development Services | APTech Solution Ankleshwar</title>
  <meta 
    name="description" 
    content="APTech Solution offers expert Salesforce development, integration, and customization services to streamline your business operations in Ankleshwar, Gujarat, India." 
  />
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Salesforce Development",
        "provider": {
          "@type": "Organization",
          "name": "APTech Solution",
          "url": "https://aptechsolution.com"
        },
        "areaServed": {
          "@type": "Place",
          "name": "Ankleshwar, Gujarat, India"
        },
        "description": "APTech Solution offers Salesforce development, integration, and customization services to streamline your business operations."
      }
    `}
  </script>
</Helmet>

            {/* Hero Section */}
            <section className="salesforce-hero">
                <h1>Salesforce Development Services</h1>
                <p>
                    Empower your business with custom Salesforce solutions tailored to enhance productivity,
                    improve customer engagement, and streamline operations.
                </p>
               
                <img src={salesforcepic} alt="Salesforce Development" />
            </section>

            {/* Services Section */}
            <section className="salesforce-services">
                <h2>Our Salesforce Services</h2>
                <div className="salesforce-services-grid">
                    <div className="salesforce-card">
                        <FaCloud />
                        <h3>Custom Salesforce Apps</h3>
                        <p>Design and develop tailored apps that extend Salesforce functionality to fit your business needs.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaCogs />
                        <h3>Salesforce Integration</h3>
                        <p>Seamlessly integrate Salesforce with ERP, third-party apps, and legacy systems.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaChartLine />
                        <h3>Sales Cloud & Service Cloud</h3>
                        <p>Leverage Sales & Service Cloud for pipeline automation, CRM, and enhanced support.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaLock />
                        <h3>Security & Compliance</h3>
                        <p>Ensure your Salesforce org is secure, compliant, and protected from vulnerabilities.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaSyncAlt />
                        <h3>Migration & Upgrades</h3>
                        <p>Effortless Salesforce data migration, org upgrades, and legacy transformation.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaUsers />
                        <h3>Admin & Support</h3>
                        <p>Get dedicated Salesforce administrators and round-the-clock support services.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaTools />
                        <h3>DevOps for Salesforce</h3>
                        <p>Automate deployments and manage environments with CI/CD best practices.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaMobileAlt />
                        <h3>Mobile-First Solutions</h3>
                        <p>Deliver mobile-responsive Salesforce experiences for on-the-go productivity.</p>
                    </div>
                    <div className="salesforce-card">
                        <FaCodeBranch />
                        <h3>Version Control & Sandbox</h3>
                        <p>Leverage branching strategies and sandbox setups for safe development and testing.</p>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="salesforce-why-choose">
                <h2>Why Choose Our Salesforce Developers?</h2>
                <div className="salesforce-choose-grid">
                    <div className="choose-card1">
                        <h5>Certified Professionals</h5>
                        <p>Team of Salesforce Certified Developers and Administrators.</p>
                    </div>
                    <div className="choose-card1">
                        <h5>End-to-End Solutions</h5>
                        <p>From consulting to deployment and post-launch support.</p>
                    </div>
                    
                    <div className="choose-card1">
                        <h5>Custom Focus</h5>
                        <p>Solutions built around your specific business objectives and workflows.</p>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="salesforce-cta">
                <h2>Start Your Salesforce Journey Today</h2>
                <p>Let’s build smarter, scalable, and efficient solutions with Salesforce.</p>

                <Link to="/contact" state={{ scrollTo: "form" }}>
                    <p className="salesforce-cta-button">Get a Free Quote</p>
                </Link>
               
            </section>
        </div>
    );
};

export default SalesforceDevelopment;
